import React from 'react';

function Watch({
  lineColor = '#9FA3B3',
  width = 14,
  height = 14,
  style = {}
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 15"
      fill="none"
      style={{ ...style }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82193 8.04763H7.95108C8.23565 8.04763 8.46536 7.82915 8.46536 7.5585C8.46536 7.28785 8.23565 7.06937 7.95108 7.06937H6.33622V4.50959C6.33622 4.23894 6.1065 4.02046 5.82193 4.02046C5.53736 4.02046 5.30765 4.23894 5.30765 4.50959V7.5585C5.30765 7.82915 5.53736 8.04763 5.82193 8.04763ZM8.43441 13.6207C8.43441 13.7087 8.35898 13.7837 8.26298 13.7837H3.37726C3.28469 13.7837 3.20584 13.7087 3.20584 13.6207V12.3261C4.01498 12.7337 4.93384 12.9685 5.90755 12.9685C6.81612 12.9685 7.66984 12.7631 8.43441 12.4044V13.6207ZM1.14869 7.46398C1.14869 4.96942 3.28469 2.94115 5.90755 2.94115C8.53041 2.94115 10.663 4.96942 10.663 7.46398C10.663 9.95855 8.53041 11.9901 5.90755 11.9901C3.28469 11.9901 1.14869 9.95855 1.14869 7.46398ZM3.20584 1.2292C3.20584 1.13789 3.28469 1.06615 3.37726 1.06615H8.26298C8.35898 1.06615 8.43441 1.13789 8.43441 1.2292V2.52376C7.66984 2.16833 6.81612 1.96289 5.90755 1.96289C4.93384 1.96289 4.01498 2.19442 3.20584 2.60202V1.2292ZM11.6915 7.46398C11.6915 5.70311 10.8138 4.13463 9.45612 3.12702C9.45955 3.10093 9.46297 3.07485 9.46297 3.0455V1.22919C9.46297 0.599847 8.92469 0.0878906 8.26297 0.0878906H3.37726C2.71555 0.0878906 2.17726 0.599847 2.17726 1.22919V3.16615C2.17726 3.1955 2.18412 3.22485 2.18755 3.2542C0.925832 4.26506 0.120117 5.77485 0.120117 7.46398C0.120117 9.14659 0.922403 10.6564 2.17726 11.664V13.6205C2.17726 14.2498 2.71555 14.7618 3.37726 14.7618H8.26297C8.92469 14.7618 9.46297 14.2498 9.46297 13.6205V11.7944C10.8173 10.7868 11.6915 9.22159 11.6915 7.46398Z"
        fill={lineColor}
      />
    </svg>
  );
}

export default Watch;
